import { render, staticRenderFns } from "./grupi2.vue?vue&type=template&id=584d4466&scoped=true&"
import script from "./grupi2.vue?vue&type=script&lang=js&"
export * from "./grupi2.vue?vue&type=script&lang=js&"
import style0 from "./grupi2.vue?vue&type=style&index=0&id=584d4466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d4466",
  null
  
)

export default component.exports